import { useState, useCallback } from 'react';

/**
 * useAgentFactory — Hook for managing agent factory blueprints
 */
export default function useAgentFactory() {
  const [blueprints, setBlueprints] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadBlueprints = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/agent-factory/blueprints');
      if (res.ok) setBlueprints(await res.json());
    } catch (e) {
      console.warn('[useAgentFactory] Failed to load blueprints:', e);
    } finally {
      setLoading(false);
    }
  }, []);

  const saveBlueprint = useCallback(async (blueprint) => {
    try {
      const res = await fetch('/api/agent-factory/blueprints', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(blueprint),
      });
      if (res.ok) return await res.json();
    } catch (e) {
      console.warn('[useAgentFactory] Failed to save blueprint:', e);
    }
    return null;
  }, []);

  const deleteBlueprint = useCallback(async (id) => {
    try {
      await fetch(`/api/agent-factory/blueprints/${id}`, { method: 'DELETE' });
      setBlueprints(prev => prev.filter(b => b.id !== id));
    } catch (e) {
      console.warn('[useAgentFactory] Failed to delete blueprint:', e);
    }
  }, []);

  return { blueprints, loading, loadBlueprints, saveBlueprint, deleteBlueprint };
}
